import { useFormContext } from 'react-hook-form';
import { Typography } from '@material-ui/core';

export const NutritionistSearchTestStep4Form = () => {
  const form = useFormContext();

  return <Typography>Step 4 form</Typography>;
};
